export default __webpack_public_path__ + "static/media/tt2.776b24ee.png";